export default {

  shortenString: function (str, maxLength) {
    maxLength = maxLength || 22;
    if (!str)
      return '';
    return (str.length > maxLength)
      ? str.substring(0, maxLength) + "..."
      : str;
  }
};
